<div class="home-banner d-lg-flex d-none">
  <div class="container d-flex justify-content-between align-items-center h-100">
    <ng-container *ifScreenSize="screenType.Desktop">
      <div class="text-white">
        <div class="d-flex align-items-center mb-2 cursor-pointer" [routerLink]="'/account'">
          <h1 class="mb-0">{{ 'home.page.title' | translate }} {{ name$ | async }}!</h1>
          <span class="icon material-icons">chevron_right</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ifScreenSize="screenType.Mobile">
  <fgb-barcode [showMobileMenu]="true" [showMobileNavigation]="true"></fgb-barcode>
</ng-container>

<!--Voucher-->
<div class="container mt-lg-3">
  <fgb-vouchers></fgb-vouchers>
</div>

<!--Scorecard Carousel-->
<fgbcl-scorecard-carousel [showAllView]="true" [icon]="'chevron_right'" [isSponsorInBody]="true"></fgbcl-scorecard-carousel>

<!-- Featured Rewards -->
<div class="container">
  <div class="row">
    <div class="col-lg-12">
      <fgbcl-featured-rewards [showAllPath]="'rewards'"></fgbcl-featured-rewards>
    </div>
  </div>

  <!-- Announcements -->
  <fgbcl-announcements></fgbcl-announcements>
</div>
